import { render, staticRenderFns } from "./ClusterTeachersAppraisal.vue?vue&type=template&id=0a3c5780&scoped=true&"
import script from "./ClusterTeachersAppraisal.vue?vue&type=script&lang=js&"
export * from "./ClusterTeachersAppraisal.vue?vue&type=script&lang=js&"
import style0 from "./ClusterTeachersAppraisal.vue?vue&type=style&index=0&id=0a3c5780&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3c5780",
  null
  
)

export default component.exports